import { Typography } from '@mui/material';
import React from 'react';
import SettingsStructure from '../SettingsStructure';

const Rules = () => {
  return <SettingsStructure option={4} title="Rules" button={false} />;
};

export default Rules;
